// UserDiagnostic Component
// Diagnostic page to debug user sync issues

import React, { useState } from 'react';
import { useUser } from '../context/UserContext';
import styles from './UserDiagnostic.module.css';

const UserDiagnostic = () => {
  const { user, userProfile, loading, isNewUser } = useUser();
  const [syncResult, setSyncResult] = useState(null);
  const [syncing, setSyncing] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

  const manualSync = async () => {
    if (!user) {
      alert('No Firebase user logged in!');
      return;
    }

    setSyncing(true);
    try {
      console.log('=== MANUAL SYNC STARTED ===');
      
      const payload = {
        email: user.email,
        firstName: user.displayName?.split(' ')[0] || '',
        lastName: user.displayName?.split(' ').slice(1).join(' ') || '',
        profilePicture: user.photoURL || '',
        firebaseUid: user.uid,
        roles: ['player'],
        isVerified: user.emailVerified || false
      };

      console.log('Payload:', JSON.stringify(payload, null, 2));

      const response = await fetch(`${BACKEND_URL}/api/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log('Response:', data);
      
      setSyncResult({
        status: response.status,
        data: data
      });

      if (response.ok) {
        alert('User synced successfully! Refresh the page.');
      } else {
        alert(`Sync failed: ${data.message}`);
      }
    } catch (err) {
      console.error('Sync error:', err);
      setSyncResult({
        error: err.message
      });
      alert(`Error: ${err.message}`);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className={styles.container}>
      <h1>User Diagnostic</h1>
      
      <div className={styles.section}>
        <h2>Firebase User</h2>
        {user ? (
          <pre className={styles.code}>
            {JSON.stringify({
              uid: user.uid,
              email: user.email,
              displayName: user.displayName,
              emailVerified: user.emailVerified,
              photoURL: user.photoURL
            }, null, 2)}
          </pre>
        ) : (
          <p>No Firebase user (not logged in)</p>
        )}
      </div>

      <div className={styles.section}>
        <h2>MongoDB User Profile</h2>
        {userProfile ? (
          <pre className={styles.code}>
            {JSON.stringify({
              _id: userProfile._id,
              email: userProfile.email,
              firstName: userProfile.firstName,
              lastName: userProfile.lastName,
              firebaseUid: userProfile.firebaseUid,
              roles: userProfile.roles
            }, null, 2)}
          </pre>
        ) : (
          <p style={{ color: 'red' }}>❌ No MongoDB user profile loaded</p>
        )}
      </div>

      <div className={styles.section}>
        <h2>Status</h2>
        <ul>
          <li>Loading: {loading ? 'Yes' : 'No'}</li>
          <li>Is New User: {isNewUser ? 'Yes' : 'No'}</li>
          <li>User Synced: {userProfile ? '✅ Yes' : '❌ No'}</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2>Actions</h2>
        <button 
          onClick={manualSync}
          disabled={syncing || !user}
          className={styles.button}
        >
          {syncing ? 'Syncing...' : 'Manually Sync User to Backend'}
        </button>

        {syncResult && (
          <div className={styles.result}>
            <h3>Sync Result:</h3>
            <pre className={styles.code}>
              {JSON.stringify(syncResult, null, 2)}
            </pre>
          </div>
        )}
      </div>

      <div className={styles.section}>
        <h2>Quick Links</h2>
        <ul>
          <li><a href={`/player-profile/${userProfile?._id || user?.uid}`}>My Player Profile</a></li>
          <li><a href={`/player-profile/${userProfile?._id || user?.uid}/edit`}>Edit/Create Profile</a></li>
        </ul>
      </div>
    </div>
  );
};

export default UserDiagnostic;




